import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatTableDataSource, MatTableModule} from '@angular/material/table';
import {CommonModule} from '@angular/common';
import {MatCardModule} from '@angular/material/card';
import {MatDividerModule} from '@angular/material/divider';

import {AppCodeViewComponent} from 'src/app/components/code-view/code-view.component';
import {MatTab, MatTabChangeEvent, MatTabGroup, MatTabLabel} from "@angular/material/tabs";
import {MatFormField, MatInput, MatLabel} from "@angular/material/input";
import {FormArray, FormControl, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {UserDecisionOptionsComponent} from "../user-decision-options/user-decision-options.component";
import {MatOption} from "@angular/material/autocomplete";
import {MatSelect} from "@angular/material/select";
import {FilterTypes} from "../../file";
import {TablerIconsModule} from "angular-tabler-icons";
import {MatTooltip} from "@angular/material/tooltip";
import {ToastrService} from "ngx-toastr";
import {MatButton} from "@angular/material/button";


@Component({
  selector: 'app-excel-table',
  imports: [
    MatCardModule,
    MatTableModule,
    CommonModule,
    MatPaginatorModule,
    MatDividerModule,
    MatTabGroup,
    MatTab,
    AppCodeViewComponent,
    MatTabLabel,
    MatInput,
    FormsModule,
    MatFormField,
    MatLabel,
    UserDecisionOptionsComponent,
    MatOption,
    MatSelect,
    ReactiveFormsModule,
    TablerIconsModule,
    MatTooltip,
    MatButton,
  ],
  templateUrl: './excel-table.component.html',
  styleUrls: ['./excel-table.component.scss'],
})
export class AppPaginationExcelTableComponent implements OnInit {

  displayedColumns = ['assigned', 'name', 'priority', 'budget'];
  dataSource = new MatTableDataSource<any>();
  filterTypes = Object.keys(FilterTypes)
  dateFormatOptions: string[];
  @Input() userDecision: Object[];

  @Input() formGroup: any;
  @Input() getOptionTypeIcon: (key: string) => string = () => 'info-circle';
  @Input() uploadedFilesLength: number;
  @Output() userDecisionChangeEvent = new EventEmitter<[string, boolean, number]>();
  @Output() sheetHeaderChangeEvent = new EventEmitter<[number, number, string]>();
  @Output() columnMappingsChange = new EventEmitter<[string, string, string, string]>();
  @Output() columnMappingsTypeChange = new EventEmitter<[string, string, string]>();
  @Output() updateDivisionColumnsChange = new EventEmitter<string>();
  @Input() selectedDivisionType: string;
  @Input() selectedColumns: Object;

  constructor(private toastService: ToastrService) {}

  ngOnInit(): void {
    if (this.sheetsOfExcel) {
      this.setOrganizationSheetNameIfExist(this.sheetsOfExcel[0].name)
    }
  }

  guessDateFormats(input) {
    input.toString()
    const possibleFormats = [];
    const cleanedInput = typeof input === "string" ? input.trim() : '';

    const monthNames = {
      January: 1, February: 2, March: 3, April: 4,
      May: 5, June: 6, July: 7, August: 8,
      September: 9, October: 10, November: 11, December: 12,
    };
    const shortMonthNames = Object.keys(monthNames).map(m => m.substr(0, 3));
    const datePatterns = [
      { format: 'MM/DD/YYYY', regex: /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/ },
      { format: 'DD/MM/YYYY', regex: /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/ },
      { format: 'YYYY/MM/DD', regex: /^(\d{4})\/(\d{1,2})\/(\d{1,2})$/ },
      { format: 'MM-DD-YYYY', regex: /^(\d{1,2})-(\d{1,2})-(\d{4})$/ },
      { format: 'DD-MM-YYYY', regex: /^(\d{1,2})-(\d{1,2})-(\d{4})$/ },
      { format: 'YYYY-MM-DD', regex: /^(\d{4})-(\d{1,2})-(\d{1,2})$/ },
      { format: 'MM.DD.YYYY', regex: /^(\d{1,2})\.(\d{1,2})\.(\d{4})$/ },
      { format: 'DD.MM.YYYY', regex: /^(\d{1,2})\.(\d{1,2})\.(\d{4})$/ },
      { format: 'YYYY.MM.DD', regex: /^(\d{4})\.(\d{1,2})\.(\d{1,2})$/ },
      { format: 'MMMM D, YYYY', regex: /^([A-Za-z]+) (\d{1,2}), (\d{4})$/ },
      { format: 'D MMMM YYYY', regex: /^(\d{1,2}) ([A-Za-z]+) (\d{4})$/ },
      { format: 'MMMM D YYYY', regex: /^([A-Za-z]+) (\d{1,2}) (\d{4})$/ },
      { format: 'MMM D, YYYY', regex: /^([A-Za-z]{3}) (\d{1,2}), (\d{4})$/ },
      { format: 'D MMM YYYY', regex: /^(\d{1,2}) ([A-Za-z]{3}) (\d{4})$/ },
      { format: 'MMM D YYYY', regex: /^([A-Za-z]{3}) (\d{1,2}) (\d{4})$/ },
      { format: 'YYYYMMDD', regex: /^(\d{4})(\d{2})(\d{2})$/ },
      { format: 'DDMMYYYY', regex: /^(\d{2})(\d{2})(\d{4})$/ },
      { format: 'MMDDYYYY', regex: /^(\d{2})(\d{2})(\d{4})$/ },
    ];
    for (const pattern of datePatterns) {
      const match = cleanedInput.match(pattern.regex);
      if (!match) continue;
      let day, month, year;
      switch (pattern.format) {
        case 'MM/DD/YYYY':
        case 'MM-DD-YYYY':
        case 'MM.DD.YYYY':
          month = +match[1];
          day = +match[2];
          year = +match[3];
          break;
        case 'DD/MM/YYYY':
        case 'DD-MM-YYYY':
        case 'DD.MM.YYYY':
          day = +match[1];
          month = +match[2];
          year = +match[3];
          break;
        case 'YYYY/MM/DD':
        case 'YYYY-MM-DD':
        case 'YYYY.MM.DD':
          year = +match[1];
          month = +match[2];
          day = +match[3];
          break;
        case 'MMMM D, YYYY':
        case 'MMMM D YYYY':
          month = monthNames[match[1]];
          day = +match[2];
          year = +match[3];
          break;
        case 'D MMMM YYYY':
          day = +match[1];
          month = monthNames[match[2]];
          year = +match[3];
          break;
        case 'MMM D, YYYY':
        case 'MMM D YYYY':
          month = shortMonthNames.indexOf(match[1]) + 1;
          day = +match[2];
          year = +match[3];
          break;
        case 'D MMM YYYY':
          day = +match[1];
          month = shortMonthNames.indexOf(match[2]) + 1;
          year = +match[3];
          break;
        case 'YYYYMMDD':
          year = +match[1];
          month = +match[2];
          day = +match[3];
          break;
        case 'DDMMYYYY':
          day = +match[1];
          month = +match[2];
          year = +match[3];
          break;
        case 'MMDDYYYY':
          month = +match[1];
          day = +match[2];
          year = +match[3];
          break;
      }
      if (this.isValidDate(year, month, day)) {
        possibleFormats.push(pattern.format);
      }
    }
    return possibleFormats;
  }

  isValidDate(y, m, d) {
    const date = new Date(y, m - 1, d);
    return (
        date.getFullYear() === y &&
        date.getMonth() === m - 1 &&
        date.getDate() === d
    );
  }

  changeUserDecision(updatedDecisionKey: string, userDecisionValue: boolean, sheetIndex: number) {
    this.userDecisionChangeEvent.emit([updatedDecisionKey, userDecisionValue, sheetIndex]);
  }

  updateSheetHeader(sheetIndex: number, columnIndex: number, value: string){
    // Parent component'e bildir (form control zaten doğrudan bağlı)
    this.sheetHeaderChangeEvent.emit([sheetIndex, columnIndex, value])
  }

  addOrUpdateColumnMappings(key: string, fieldName: string, type: string, dateType: string) {
    this.columnMappingsChange.emit([key, fieldName, type ? type : undefined, dateType ? dateType : undefined])
  }

  updateSheetHeaderType(sheetIndex: number, columnIndex: number, column: string, value: string){
    const sheetHeaders = (this.formGroup.get('sheets').at(sheetIndex).get('sheetHeaders') as FormArray)
    if (sheetHeaders) {
      (this.formGroup.get('sheets').at(sheetIndex).get('sheetHeaders') as FormArray).at(columnIndex).get('type').setValue(value === undefined ? '' : value)
    }
    if (value === 'DATE' && column !== undefined) {
      this.dateFormatOptions = this.guessDateFormats((this.sheetsOfExcel[sheetIndex] as any).rows[1][column])
    }
  }

  selectDateTypes(sheetIndex: number, columnIndex: number, dateType: string){
    const sheetHeaders = (this.formGroup.get('sheets').at(sheetIndex).get('sheetHeaders') as FormArray)
    if (sheetHeaders) {
      (this.formGroup.get('sheets').at(sheetIndex).get('sheetHeaders') as FormArray).at(columnIndex).get('type').setValue(`DATE|${dateType}`)
    }
  }

  onTabChange(event: MatTabChangeEvent) {
    const selectedSheetName = this.sheetsOfExcel[event.index].name
    if (selectedSheetName) {
      this.setOrganizationSheetNameIfExist(selectedSheetName);
    }
  }

  setOrganizationSheetNameIfExist(sheetName: string) {
    if (this.formGroup.get('organizationSheetName')) {
      this.formGroup.get('organizationSheetName').setValue(sheetName);
    }
  }

  updateDivisionColumns(existingFieldName: string){
    this.updateDivisionColumnsChange.emit(existingFieldName);
    this.selectedColumns = {};
    (this.formGroup.get('divisionColumns') as FormArray).controls.forEach((control: FormControl) => {
      const rawValue = control.getRawValue()
      this.selectedColumns[rawValue.existingFieldName] = {
        index: rawValue.divisionOrder
      }
    })
  }

  getFilteredDataSource(sheet: any, i: number): MatTableDataSource<any>{
    const sheetTitleExists = this.formGroup?.get('sheets')?.at(i)?.get('sheetTitleExists')?.value.value;
    const data = sheetTitleExists ? sheet.dataSource.data.slice(1) : sheet.dataSource.data;
    return new MatTableDataSource<any>(data);
  }

  sheetsOfExcel: {
    name: string;
    columns: string[];
    dataSource: MatTableDataSource<any>;
  }[] = [];

  @Input() set excelData(data: any[]) {
    if (data.length > 0) {
      this.sheetsOfExcel = data.map(sheet => ({
        ...sheet,
        dataSource: new MatTableDataSource(sheet.rows)
      }))
      // (this.dataSource.data as { name: string; columns: string[]; rows: unknown[] }[]) = data;
    }
  }
  protected readonly console = console;
}
